import { render, staticRenderFns } from "./msg-list.vue?vue&type=template&id=858e8b1e"
import script from "./msg-list.vue?vue&type=script&lang=ts"
export * from "./msg-list.vue?vue&type=script&lang=ts"
import style0 from "./msg-list.vue?vue&type=style&index=0&id=858e8b1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports